export default __webpack_public_path__ + "static/media/72-min.9e06f851.jpg";